import { Map, List } from 'immutable';
// - Import action types
import { CircleActionType } from 'constants/circleActionType';
import { CircleState } from './CircleState';
/**
 * Add circle
 */
var addCircle = function (state, payload) {
    var circle = payload.circle;
    return state
        .setIn(['circleList', circle.get('id')], payload.circle);
};
/**
 * Update circle
 */
var updateCircle = function (state, payload) {
    var circle = payload.circle;
    return state
        .setIn(['openSetting', circle.get('id')], false)
        .setIn(['circleList', circle.get('id')], payload.circle);
};
/**
 * Circle reducer
 * @param state
 * @param action
 */
export var circleReducer = function (state, action) {
    if (state === void 0) { state = Map(new CircleState()); }
    var payload = action.payload;
    switch (action.type) {
        case CircleActionType.CLEAR_ALL_CIRCLES:
            return Map(new CircleState());
        case CircleActionType.ADD_CIRCLE: return addCircle(state, payload);
        case CircleActionType.UPDATE_CIRCLE: return updateCircle(state, payload);
        case CircleActionType.DELETE_CIRCLE:
            return state
                .deleteIn(['circleList', payload.circleId]);
        case CircleActionType.ADD_LIST_CIRCLE:
            return state
                .set('loaded', true)
                .mergeIn(['circleList'], payload.circleList);
        case CircleActionType.ADD_FOLLOWING_USER:
            var userTie = payload.userTie;
            return state
                .setIn(['userTies', userTie.get('userId')], payload.userTie)
                .setIn(['selectedCircles', userTie.get('userId')], userTie.get('circleIdList'));
        case CircleActionType.UPDATE_USER_TIE:
            return state
                .setIn(['userTies', payload.userTie.user.userId], payload.userTie);
        case CircleActionType.ADD_USER_TIE_LIST:
            return state
                .mergeIn(['userTies'], payload.userTies)
                .set('selectedCircles', getSelectedCircles(payload.userTies));
        case CircleActionType.ADD_USER_TIED_LIST:
            return state
                .mergeIn(['userTieds'], payload.userTieds);
        case CircleActionType.DELETE_USER_FROM_CIRCLE:
            return state
                .deleteIn(['userTies', payload.userTie.user.userId, 'circleIdList', payload.circleId]);
        case CircleActionType.DELETE_FOLLOWING_USER:
            return state
                .deleteIn(['userTies', payload.userId])
                .deleteIn(['selectedCircles', payload.userId]);
        /**
         * User interface stuffs
         */
        case CircleActionType.CLOSE_CIRCLE_SETTINGS:
            return state
                .setIn(['openSetting', payload.circleId], false);
        case CircleActionType.OPEN_CIRCLE_SETTINGS:
            return state
                .setIn(['openSetting', payload.circleId], true);
        case CircleActionType.SHOW_SELECT_CIRCLE_BOX:
            return state
                .setIn(['selectCircleStatus', payload.userId], true);
        case CircleActionType.HIDE_SELECT_CIRCLE_BOX:
            return state
                .setIn(['selectCircleStatus', payload.userId], false);
        case CircleActionType.SHOW_FOLLOWING_USER_LOADING:
            return state
                .setIn(['followingLoadingStatus', payload.userId], true);
        case CircleActionType.HIDE_FOLLOWING_USER_LOADING:
            return state
                .setIn(['followingLoadingStatus', payload.userId], false);
        case CircleActionType.SET_SELECTED_CIRCLES_USER_BOX_COMPONENT:
            return state
                .setIn(['selectedCircles', payload.userId], payload.circleList);
        case CircleActionType.REMOVE_SELECTED_CIRCLES_USER_BOX_COMPONENT:
            return state
                .setIn(['selectedCircles', payload.userId], []);
        case CircleActionType.OPEN_SELECT_CIRCLES_USER_BOX_COMPONENT:
            return state
                .setIn(['openSelecteCircles', payload.userId], true);
        case CircleActionType.CLOSE_SELECT_CIRCLES_USER_BOX_COMPONENT:
            return state
                .setIn(['openSelecteCircles', payload.userId], false);
        default:
            return state;
    }
};
/**
 * Map user ties selected to selected circles
 */
var getSelectedCircles = function (userTies) {
    var selectedCircles = Map({});
    Object.keys(userTies).forEach(function (userId) {
        var userTie = userTies[userId];
        selectedCircles = selectedCircles.set(userTie.userId, List(userTie.circleIdList));
    });
    return selectedCircles;
};



//////////////////
// WEBPACK FOOTER
// ./src/store/reducers/circles/circleReducer.ts
// module id = 554
// module chunks = 50